export const OIDC_MAX_REFRESH_BUFFER_MS = 5 * 60 * 1000;
export const OIDC_MIN_REFRESH_BUFFER_MS = 30 * 1000;
export const HUMHUB_MAX_REFRESH_BUFFER_MS = 5 * 60 * 1000;
export const HUMHUB_MIN_REFRESH_BUFFER_MS = 30 * 1000;
export const MIN_SESSION_REFRESH_DELAY_MS = 30 * 1000;
export const SESSION_REFRESH_RETRY_DELAY_MS = 60 * 1000;
export const AUTH_FLOW_TOKEN_EXPIRATION_BUFFER_MS = 5 * 1000;
